import React from "react"
import { Link } from "gatsby"
import {
  RegBody,
  SemiBdTitle3,
} from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import ProductEntryHowItWorksCard from "./ProductEntryHowItWorksCard"

export interface ProductEntryHowItWorksProps {
  howItWorks: {
    header: string
    body: string
    on: boolean
    steps: {
      [key: string]: string
    }
  }
}

const ProductEntryHowItWorks = ({
  howItWorks,
}: ProductEntryHowItWorksProps) => {
  if (!howItWorks?.on) return null

  return (
    <ProductEntryHowItWorksStyled>
      <div className="product-entry-how-it-works__container">
        <div className="product-entry-how-it-works__text-container">
          <SemiBdTitle3 className="product-entry-how-it-works__header">
            {howItWorks?.header && howItWorks.header}
          </SemiBdTitle3>
          <RegBody className="product-entry-how-it-works__body">
            {howItWorks?.body && howItWorks.body}
          </RegBody>
        </div>
        <div className="product-entry-how-it-works__cards-container">
          <ProductEntryHowItWorksCard
            number={1}
            title={howItWorks.steps.step1Title}
            body={howItWorks.steps.step1Body}
          />
          <ProductEntryHowItWorksCard
            number={2}
            title={howItWorks.steps.step2Title}
            body={howItWorks.steps.step2Body}
          />
          <ProductEntryHowItWorksCard
            number={3}
            title={howItWorks.steps.step3Title}
            body={howItWorks.steps.step3Body}
          />
        </div>
        {/* <div className="product-entry-how-it-works__card-link-container">
          <Link to="/" className="product-entry-how-it-works__card-link">
            <div className="product-entry-how-it-works__card-link-icon-container">
              <IconChevronRight color="var(--color-primary)" />
            </div>
            <SemiBdTitle4 className="product-entry-how-it-works__card-link-text">
              Find out how
            </SemiBdTitle4>
          </Link>
        </div> */}
      </div>
    </ProductEntryHowItWorksStyled>
  )
}

export default ProductEntryHowItWorks

const ProductEntryHowItWorksStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem(104)} ${rem(16)} 0;

  @media ${media.midUp} {
    padding: ${rem(128)} ${rem(64)} 0;
  }

  @media ${media.stMidUp} {
    padding-top: ${rem(136)};
  }

  .product-entry-how-it-works__text-container {
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
    text-align: center;
    padding: 0 ${rem(51)} ${rem(32)};

    @media ${media.midUp} {
      gap: ${rem(24)};
      padding-bottom: ${rem(48)};
    }

    @media ${media.stMidUp} {
      align-items: center;
      gap: ${rem(16)};
      padding-bottom: ${rem(56)};
    }

    .product-entry-how-it-works__header {
      @media ${media.midUp} {
        font-size: ${rem(40)};
        line-height: ${rem(48)};
        max-width: ${rem(540)};
      }

      @media ${media.stMidUp} {
        max-width: ${rem(637)};
      }
    }
  }

  .product-entry-how-it-works__cards-container {
    display: grid;
    align-items: stretch;
    gap: ${rem(24)};

    @media ${media.stMidUp} {
      grid-template-columns: repeat(3, 1fr);
      gap: ${rem(56)};
    }
  }

  .product-entry-how-it-works__card-link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: ${rem(48)};

    @media ${media.stMidUp} {
      padding-top: ${rem(56)};
    }

    .product-entry-how-it-works__card-link {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: ${rem(8)};
      color: var(--color-primary);
      text-decoration: none;
    }

    .product-entry-how-it-works__card-link-icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${rem(32)};
      height: ${rem(32)};
      border: 1px solid var(--color-primary);
      border-radius: ${rem(32)};
    }

    .product-entry-how-it-works__card-link-text {
      @media ${media.stMidUp} {
        font-size: ${rem(20)};
      }
    }
  }
`
